import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Modal from '../../molecules/Modal';
import Radio from '../../atoms/Radio';
import Paragraph from '../../atoms/Paragraph';
import Flex from '../../atoms/Flex';
import Button from '../../atoms/Button';
import { useTranslation } from 'react-i18next';
import { useForm } from '@inertiajs/react';
import ErrorLabel from '../../atoms/labels/ErrorLabel';
import TextareaItem from '../../molecules/TextareaItem';
import { useTheme } from 'styled-components';
const CloseDossierModal = ({ open, dossierNumber, setDossierModalOpen, }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { put, data, setData, errors, reset, processing } = useForm({
        reason: '',
        description: '',
    });
    const handleSubmit = (e) => {
        e.preventDefault();
        put(`/dossier/${dossierNumber}/dossier-sluiten`, {
            preserveScroll: true,
            onSuccess: () => {
                handleClose();
            },
        });
    };
    const handleClose = () => {
        setDossierModalOpen(false);
        reset();
    };
    const handleChange = (e) => {
        // @ts-ignore
        setData(e.target.name, e.target.value);
    };
    return (_jsx(_Fragment, { children: _jsxs(Modal, { title: t('close_dossier.title'), open: open, onClose: handleClose, children: [_jsx(Paragraph, { children: t('close_dossier.paragraph') }), _jsxs("form", { onSubmit: handleSubmit, children: [_jsxs(Flex, { column: true, children: [_jsx(Radio, { label: t('close_dossier.reason.dismissal'), value: t('close_dossier.reason.dismissal'), name: "reason", disabled: processing, checked: data.reason ===
                                        t('close_dossier.reason.dismissal'), required: true, onChange: handleChange }), _jsx(Radio, { label: t('close_dossier.reason.objection_justified'), value: t('close_dossier.reason.objection_justified'), name: "reason", disabled: processing, checked: data.reason ===
                                        t('close_dossier.reason.objection_justified'), required: true, onChange: handleChange }), _jsx(Radio, { label: t('close_dossier.reason.other_reason'), value: t('close_dossier.reason.other_reason'), name: "reason", disabled: processing, checked: data.reason ===
                                        t('close_dossier.reason.other_reason'), required: true, onChange: handleChange }), errors?.reason && (_jsx(ErrorLabel, { children: errors?.reason })), _jsx(TextareaItem, { fullWidth: true, label: t('close_dossier.description'), placeholder: t('close_dossier.description_placeholder'), value: data.description, disabled: processing, error: errors.description, name: "description", onChange: handleChange })] }), _jsxs(Flex, { column: true, children: [_jsx(Button, { transparent: true, fullWidth: true, textAlign: 'center', disabled: processing, onClick: handleClose, type: 'button', margin: "0 0 10px 0", children: t('close_dossier.cancel') }), _jsx(Button, { secondary: true, fullWidth: true, textAlign: 'center', isLoading: processing, type: 'submit', 
                                    //@ts-ignore
                                    loaderColor: theme.primary.dark, children: t('close_dossier.submit') })] })] })] }) }));
};
export default CloseDossierModal;
